export default "__VITE_ASSET__53b844e4__"